import { Component } from '@angular/core';

@Component({
  selector: 'fgb-photo-scramble-leaderboard-page',
  templateUrl: './photo-scramble-leaderboard-page.component.html',
  styleUrl: './photo-scramble-leaderboard-page.component.scss',
})
export class PhotoScrambleLeaderboardPageComponent {
  LeaderboardType = 102;
}
